import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDeliverymen } from '~/hooks/deliverymens';

type Props = {
  onSelect: (id: string) => void;
  value: string;
};

export function SelectDeliveryman({ onSelect, value }: Props): JSX.Element {
  const { deliverymens, loadDeliverymens } = useDeliverymen();
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    if (deliverymens === null) {
      loadDeliverymens();
    }
  }, [deliverymens, loadDeliverymens]);

  return (
    <select
      style={{ border: 0 }}
      value={selected}
      onChange={event => {
        setSelected(event.target.value);
        onSelect(event.target.value);
      }}
    >
      <option value="">Selecionar entregador...</option>
      {deliverymens &&
        deliverymens?.map(item => (
          <option key={item.uid} value={item.uid}>
            {item.name}
          </option>
        ))}
    </select>
  );
}
